import { takeEvery } from 'redux-saga';
import { take, put, call } from 'redux-saga/effects';

import { loadDataAction,loadDataSuccessAction, loadDataErrorAction } from 'modules/app/actions';
import { getTimeSlots } from '../actions';
import { TIME_SLOTS } from '../constants/actionTypes';
import * as api from '../repository';


function *_fetchTimeSlots(action) {
    const {date, dom, days} = action;
    yield put(loadDataAction('timeSlots'));
    try {
        const timeSlots =  yield call(api.getTimeSlots(date, dom, days));
        yield put(getTimeSlots.success(timeSlots));
        yield put(loadDataSuccessAction('timeSlots'));
    } catch (error) {
        yield put(getTimeSlots.error(error));
        yield put(loadDataErrorAction('timeSlots', {response: error.response}, action));
    }
}

export function *fetchTimeSlots() {
    yield takeEvery(TIME_SLOTS.REQUEST, _fetchTimeSlots);
}
